import '../../utils/index.mjs';
import Statistic from './src/statistic2.mjs';
export { statisticProps } from './src/statistic.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElStatistic = withInstall(Statistic);

export { ElStatistic, ElStatistic as default };
//# sourceMappingURL=index.mjs.map
